var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "c736286541f54cee4e43107e6ce0457683ddb655"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-corp-sites@designs-for-health"] = {
  id: "c736286541f54cee4e43107e6ce0457683ddb655"
};